import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ffd0983"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "error-indicator" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-exclamation-circle fa-2x" })
], -1))
const _hoisted_3 = { key: 0 }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      (_ctx.showErrorText)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.errorText), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}